export default "__VITE_ASSET__BKY1z26P__"